"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableHeader = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TableHeaderMixin = require("../../mixins/components/TableHeaderMixin");
var StyledTableHeader = /*#__PURE__*/_styledComponents.default.thead.withConfig({
  displayName: "StyledTableHeader",
  componentId: "c11n-8-107-0__sc-1x6l2ce-0"
})(["", ""], _TableHeaderMixin.TableHeaderMixin);
exports.StyledTableHeader = StyledTableHeader;